export const KpiRow = ({ stats }) => {
  const items = [
    { key: "total", label: "Total Spaces", value: stats.total, color: "text-white" },
    { key: "available", label: "Available", value: stats.available, color: "text-white" },
    { key: "occupied", label: "Occupied", value: stats.occupied, color: "text-[#FF3B30]" },
    { key: "reserved", label: "Reserved", value: stats.reserved, color: "text-[#FFD60A]" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-testid="kpi-row">
      {items.map((i) => (
        <div
          key={i.key}
          data-testid={`kpi-${i.key}`}
          className="p-6 flex flex-col gap-2 border border-[#262626] bg-[#141414] rounded-sm"
        >
          <span className="label-tech">{i.label}</span>
          <span
            className={`text-4xl sm:text-5xl font-black tracking-tighter ${i.color}`}
            style={{ fontFamily: "Chivo, sans-serif" }}
          >
            {i.value ?? "--"}
          </span>
        </div>
      ))}
    </div>
  );
};
